import styled from "styled-components";

const OptionItemButton = styled.div`
	input[type="checkbox"] {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		border: 0;
	}

	label {
		padding: 6px 15px 7px;
		border-radius: 18px;
		background-color: #f3f3f3;
		font-size: 13px;
		font-family: "PT-medium";
		color: var(--default-color);
		line-height: 1;
		cursor: pointer;
	}

	input[type="checkbox"]:checked + label {
		background-color: var(--blue-color);
		color: #fff;
	}
`;

export default OptionItemButton;
